export default {
  myTrainingClass_check_training:'0408Web-查看培训班',
  myTrainingClass_show_training:'0407Web-显示我的培训班列表',
  myTrainingClass_check_news0602:'0602Web-查看消息',
  myTrainingClass_my_news:'我的消息',
  myTrainingClass_show_news:'0601Web-显示消息列表',
  myTrainingClass_news06:'06Web-消息',
}
